import { isSP, qs, qsAll } from '../common/utils'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Sec2_Statement {
  constructor() {
    const el = qs('.p-top-statement')
    if(!el) return
    
    const bg              = qs(".p-top-statement__bg")
    // const bg_inner1   = qs(".p-top-statement__bg__inner1")
    const bg_inner2       = qs(".p-top-statement__bg__inner2")
    const catchcopy       = qs(".p-top-statement__catchcopy")
    const catchcopy_inner = qs(".p-top-statement__catchcopy__inner")
    const txt_pc          = qs(".p-top-statement__txt .pc")
    const txt_sp          = qs(".p-top-statement__txt .sp")
    const txt_span_pc     = qsAll(".p-top-statement__txt .pc span")
    const txt_span_sp     = qsAll(".p-top-statement__txt .sp span")
    
    let motionInt = -1
    
    const options1 = {
      rootMargin: '0% 0% -7% 0%',
      threshold: [0, 1]
    }

    const io_in = new IntersectionObserver( entries =>
    {
      entries.forEach( entry =>
      {
        if(entry.isIntersecting)
        {
          catchcopy.classList.add("is-show")
          
          clearInterval(motionInt)
          motionInt = setInterval(()=>{
            
            catchcopy_inner.classList.remove("run-motion")
            
            setTimeout(()=>{
              catchcopy_inner.classList.add("run-motion")
            }, 1000/60)
          }, 4 * 1000)
        }
      })
    }, options1)


    const options2 = {
        rootMargin: '0% 0%',
        threshold: 0
    }

    const io_out = new IntersectionObserver( entries =>
    {

      entries.forEach( entry =>
      {
        if(entry.isIntersecting)
        {
        }
        else
        {
          if(entry.boundingClientRect.top > 0 && entry.intersectionRatio === 0)
          {
            catchcopy.classList.remove("is-show")
            clearInterval(motionInt)
          }
        }
      })
    }, options2)
    
    io_in.observe(catchcopy)
    io_out.observe(catchcopy)
    
    
    const val = 20
    gsap.fromTo(bg_inner2, 
      { yPercent:-val },
      {
        yPercent:val,
        duration: 1, 
        ease: "linear",
        
        scrollTrigger: {
          trigger : el,
          start   : "top bottom",
          end     : "bottom top",
          scrub   : true,
          // markers : true,
        }
    })
    
    
      
    
    const io_in2 = new IntersectionObserver( entries =>
    {

      entries.forEach( entry =>
      {
        if(entry.isIntersecting)
        {
          bg.classList.add("is-show")
        }
      })
    }, {
      rootMargin: '-50% 0% -50% 0%',
      threshold: [0, 1]
    })


    const io_out2 = new IntersectionObserver( entries =>
    {

      entries.forEach( entry =>
      {
        if(entry.isIntersecting)
        {
        }
        else
        {
          if(entry.boundingClientRect.top > 0 && entry.intersectionRatio === 0)
          {
            bg.classList.remove("is-show")
          }
        }
      })
    }, {
        rootMargin: '-1px 0%',
        threshold: 0
    })
    
    io_in2.observe(el)
    io_out2.observe(el)
  }
}
